"use client"

import Image from "next/image";
import { useState } from "react";
import UploadModal from "../shared/uploadModal";

interface HowToProps {
    title: string,
    subtitle: string,
    image: string,
    ticks: string[]
}

export default function HowTo(props: HowToProps) {

    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <div className="section-bbg-gap">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 d-flex align-items-center justify-content-center ">
                            <div className="">
                                <Image className="img-fluid tools-image" src={props.image} height={475} width={475} alt="tools-img" />
                                {/* <Image className="img-fluid" src={props.image} alt="tools-img" /> */}
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="content-box mt-md-0 mt-200">
                                <h2 className="main-heading" itemProp="name">{props.title}</h2>
                                <p className="content-box__desc fs-3 sub-desc">{props.subtitle}</p>
                                <div className="mt-lg-400 mt-200">
                                    <ul className="d-flex flex-column gap-100 fs-150 p-0">
                                        {props.ticks && props.ticks.map((tick: string, index: number) =>
                                            <>
                                                {/* <svg xmlns="http://www.w3.org/2000/svg" className="min-h-6 min-w-6 " width="25px" height="25px" viewBox="0 0 281 281"> <g id="Group_8543" data-name="Group 8543" transform="translate(-7757 1045)"> <circle id="Ellipse_1" data-name="Ellipse 1" cx="140.5" cy="140.5" r="140.5" transform="translate(7757 -1045)" fill="#40a459"></circle> <path id="Union_20_-_Outline" data-name="Union 20 - Outline" d="M115.1-9.9,134.9,9.9,64.8,80l.01.009L45.192,99.99l-55-54L9.808,26.01l35.01,34.373Z" transform="translate(7835.5 -950.5)" fill="#fff"></path> </g> </svg> */}
                                                <span className=" text-2xl col-span-11 text-left number">
                                                    <button type="button"
                                                        className="text-start mt-2 content-box__desc fs-3 sub-desc"
                                                        onClick={() => setShowModal(true)} id="edit-pdf-1" data-toggle="modal" data-target="#conversion-modal" data-modal-title="Edit PDF" data-modal-body="Drag and drop your file here to upload">
                                                        {tick}
                                                    </button>
                                                </span>
                                                {/* <li className="number">Make any edit or changes your document may need.</li> */}

                                            </>
                                        )}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <UploadModal
                title={"Edit PDF"}
                open={showModal}
                onClose={() => setShowModal(false)}
                buttonText="Select file..."
            />
        </>
    );
}
